import { createClearPropMutation, createSetPropMutation } from '@/store/utils';
import * as types from '@/store/registration/mutationTypes';

export default {
  [types.SET_IS_USER_POOL_EXISTS]: createSetPropMutation('isUserPoolExist'),
  [types.CLEAR_IS_USER_POOL_EXISTS]: createClearPropMutation('isUserPoolExist'),
  [types.REMOVE_REGISTRATION_DATA](state) {
    state.companyInfo = {};
    state.clientInfo = {};
    state.registrationInProgress = false;
    state.currentStep = 1;
    state.visitedStepsCnt = 1;
    state.filledStepsCnt = 0;
    state.regions = [];
    state.industries = [];
    state.regulations = [];
    state.cybersecurityKnowhowOptions = [];
    state.amountOfEmployees = [];
    state.loading = {};
    state.loadingErrors = {};
    state.recaptchaToken = null;
    state.emailVerificationSent = false;
    state.clientAvatar = '';
  },
  [types.REMOVE_INVITATION_CODE_DATA](state) {
    state.invitationValidationSuccessful = {};
    state.invitationValidationRecaptchaToken = null;
  },
  [types.SET_SCAN_ID]: createSetPropMutation('scanId'),
  [types.SET_WORKSPACE_ID]: createSetPropMutation('workspaceId'),
  [types.SET_COMPANY_REGISTRATION_DATA]: createSetPropMutation('companyInfo'),
  [types.SET_CLIENT_REGISTRATION_DATA]: createSetPropMutation('clientInfo'),
  [types.SET_REGISTRATION_CURRENT_STEP]: createSetPropMutation('currentStep'),
  [types.SET_REGISTRATION_FILLED_STEPS_COUNT]: createSetPropMutation('filledStepsCnt'),
  [types.SET_REGISTRATION_VISITED_STEPS_COUNT]: createSetPropMutation('visitedStepsCnt'),
  [types.SET_INVITATION_VALIDATION]: createSetPropMutation('invitationValidationSuccessful'),
  [types.SET_CLIENT_AVATAR]: createSetPropMutation('clientAvatar'),
  [types.SET_REGISTRATION_RECAPTCHA_TOKEN]: createSetPropMutation('recaptchaToken'),
  [types.SET_INVITATION_VALIDATION_RECAPTCHA_TOKEN]: createSetPropMutation('invitationValidationRecaptchaToken'),
  [types.SET_EMAIL_VERIFICATION_REQUESTED]: createSetPropMutation('emailVerificationSent'),

  [types.SET_INDUSTRIES]: createSetPropMutation('industries'),
  [types.SET_REGULATIONS]: createSetPropMutation('regulations'),
  [types.SET_OFFICE_LOCATIONS]: createSetPropMutation('regions'),
  [types.SET_COMPANY_SUGGESTIONS]: createSetPropMutation('companySuggestions'),
  [types.SET_CYBERSECURITY_KNOWHOW_OPTIONS]: createSetPropMutation('cybersecurityKnowhowOptions'),
  [types.SET_AMOUNT_OF_EMPLOYEES]: createSetPropMutation('amountOfEmployees'),
  [types.SET_COMPANY_REGISTRATION_INFO_LOADING]: createSetPropMutation('loading'),
  [types.SET_COMPANY_REGISTRATION_INFO_LOADING_ERRORS]: createSetPropMutation('loadingErrors'),
  [types.SET_WHITE_LABELING_INFO]: createSetPropMutation('whiteLabeling'),
  [types.SET_REGISTRATION_USER_EMAIL]: createSetPropMutation('registrationUserEmail'),
  [types.CLEAN_REGISTRATION_USER_EMAIL]: createClearPropMutation('registrationUserEmail'),
  [types.SET_REGISTRATION_IN_PROGRESS]: createSetPropMutation('registrationInProgress'),
};
